import React from 'react';
import AppStatusChip from '../buttons/AppStatusChip';
import styles from './EntityCard.module.scss';

/**
 * Card compatta per la vista "Carte" delle liste statiche.
 *
 * Props:
 * - avatar:   nodo o stringa (iniziali) mostrato nel quadratino
 * - title:    titolo principale (stringa)
 * - subtitle: sottotitolo
 * - status:   nodo (es. <AppStatusChip/>) mostrato in alto a destra
 * - fields:   array { label, value } → righe chiave/valore
 * - chips:    array { label, variant, icon } → riga di chip (flag/caratteristiche)
 * - actions:  nodo (bottoni azione) nel footer
 * - onClick:  apre il dettaglio (opzionale). Per l'accessibilità, quando presente
 *             il titolo diventa un <button>; il click sull'intera card è solo un
 *             miglioramento per il mouse.
 */
export default function EntityCard({
  avatar,
  title,
  subtitle,
  status,
  fields = [],
  chips = [],
  actions,
  onClick,
}) {
  const TitleEl = onClick ? 'button' : 'span';
  return (
    <article
      className={styles.card}
      aria-label={typeof title === 'string' ? title : undefined}
      onClick={onClick ? () => onClick() : undefined}
    >
      <div className={styles.head}>
        {avatar != null && (
          <div className={styles.avatar} aria-hidden="true">
            {avatar}
          </div>
        )}
        <div className={styles.titles}>
          <TitleEl
            type={onClick ? 'button' : undefined}
            className={onClick ? styles.titleBtn : styles.title}
            onClick={
              onClick
                ? (e) => {
                    e.stopPropagation();
                    onClick();
                  }
                : undefined
            }
          >
            {title}
          </TitleEl>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </div>
        {status && <div className={styles.status}>{status}</div>}
      </div>

      {fields.length > 0 && (
        <dl className={styles.fields}>
          {fields.map((f, i) => (
            <div key={i} className={styles.kv}>
              <dt className={styles.k}>{f.label}</dt>
              <dd className={styles.v}>{f.value ?? '—'}</dd>
            </div>
          ))}
        </dl>
      )}

      {chips.length > 0 && (
        <div className={styles.chips}>
          {chips.map((c, i) => (
            <AppStatusChip
              key={i}
              variant={c.variant || 'neutral'}
              icon={c.icon}
              label={c.label}
              fullCell={false}
            />
          ))}
        </div>
      )}

      {actions && (
        // stopPropagation: i bottoni azione non devono innescare l'onClick della card
        <div
          className={styles.actions}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          {actions}
        </div>
      )}
    </article>
  );
}
